import t from"react";import{mdiContentCopy as o}from"@mdi/js";import{MdIcon as e}from"./MdIcon.js";const r=({id:r="content-copy",title:i="Content Copy",...m})=>t.createElement(e,{id:r,title:i,path:o,...m});export{r as ContentCopyIcon};
